import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useStylesheets } from 'hooks/useStylesheets';
import GlobalHeader from 'pages/dashboard/components/GlobalHeader';
import BotInfo from './components/BotInfo';
import BotContent from './components/BotContent';
import KaiSelectFooter from './KaiSelectFooter';
import './KaiSelectPage.scss';
import './utilities.scss';

/**
 * KAI Select — Kinetix Air's AI-assisted AHU auto-design wizard, ported from
 * the standalone `react-js-dev` KAI Selector widget (no Backbone predecessor;
 * see django/kai_select/urls.py). Routed at /kai-select/.
 *
 * Reuses this app's shared page chrome (GlobalHeader + the common.css/
 * header.css cascade) instead of porting the source project's own Header/
 * Navbar/Footer — the source project was a separate standalone app with its
 * own header; this one lives inside KSDM's existing shell like every other
 * page.
 */

// react.html ships common.css BEFORE header.css globally, but header.css's
// #ksdm-header rules need to win over common.css's for GlobalHeader (and
// #ksdm-footer) to render correctly — same fix every other page applies
// (AhuBoardPage, PartnersPage, UserSettingsPage, ...): re-inject in the
// opposite order, appended after the globals, so the LAST occurrence of each
// sheet is header.css then common.css. Bootstrap 3.3.4 is also loaded, same
// as every other GlobalHeader page (whiteboard/partners/... pull it in via
// their own legacy page.css) — GlobalHeader's dropdown panels rely on its
// `.hide` utility to stay closed by default.
const KAI_SELECT_CSS = [
  '/static/css/common/header.css',
  '/static/css/common/common.css',
  '/static/vendor/bootstrap-3.3.4-dist/css/bootstrap.min.css',
];

const KaiSelectPage = () => {
  useDocumentTitle('KAI Select');
  const cssLoaded = useStylesheets(KAI_SELECT_CSS);

  return (
    <div className="kai-select-page">
      <GlobalHeader appName="kai-select" />
      {cssLoaded && (
        <main id="bot-page" className="bot-info h-100">
          <BotInfo>
            <BotContent />
          </BotInfo>
        </main>
      )}
      <KaiSelectFooter />
    </div>
  );
};

export default KaiSelectPage;
